module.exports = __webpack_public_path__ + "static/media/volvo.9119b63f.png";